import { IconFn, IconSvg } from "../createIcon";

export const UsersIcon: IconFn = ({ color = "#F56B55", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 44, height: 40 }} {...props}>
    <g clipPath="url(#clip0_1613_12654)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.92893 26.9289C4.8043 25.0536 7.34783 24 10 24H22C24.6522 24 27.1957 25.0536 29.0711 26.9289C30.9464 28.8043 32 31.3478 32 34V38C32 39.1046 31.1046 40 30 40C28.8954 40 28 39.1046 28 38V34C28 32.4087 27.3679 30.8826 26.2426 29.7574C25.1174 28.6321 23.5913 28 22 28H10C8.4087 28 6.88258 28.6321 5.75736 29.7574C4.63214 30.8826 4 32.4087 4 34V38C4 39.1046 3.10457 40 2 40C0.89543 40 0 39.1046 0 38V34C0 31.3478 1.05357 28.8043 2.92893 26.9289Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 4C12.6863 4 10 6.68629 10 10C10 13.3137 12.6863 16 16 16C19.3137 16 22 13.3137 22 10C22 6.68629 19.3137 4 16 4ZM6 10C6 4.47715 10.4772 0 16 0C21.5228 0 26 4.47715 26 10C26 15.5228 21.5228 20 16 20C10.4772 20 6 15.5228 6 10Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.0625 1.76392C28.3365 0.69387 29.426 0.0485236 30.4961 0.3225C32.6471 0.873253 34.5537 2.12425 35.9152 3.87828C37.2767 5.6323 38.0157 7.78957 38.0157 10.01C38.0157 12.2304 37.2767 14.3877 35.9152 16.1417C34.5537 17.8957 32.6471 19.1467 30.4961 19.6975C29.426 19.9715 28.3365 19.3261 28.0625 18.2561C27.7885 17.186 28.4339 16.0965 29.5039 15.8225C30.7945 15.492 31.9385 14.7414 32.7554 13.689C33.5723 12.6366 34.0157 11.3423 34.0157 10.01C34.0157 8.67775 33.5723 7.38338 32.7554 6.33097C31.9385 5.27855 30.7945 4.52795 29.5039 4.1975C28.4339 3.92352 27.7885 2.83397 28.0625 1.76392ZM34.0635 25.76C34.3396 24.6905 35.4305 24.0474 36.5 24.3235C38.6453 24.8774 40.5459 26.1282 41.9034 27.8793C43.2609 29.6304 43.9983 31.7828 44 33.9985V34V38C44 39.1046 43.1046 40 42 40C40.8954 40 40 39.1046 40 38V34.0015C40 34.0011 40 34.0007 40 34.0004C40 34.0002 40 34.0005 40 34.0004C39.9987 32.6715 39.5562 31.3803 38.7421 30.33C37.9276 29.2793 36.7872 28.5288 35.5 28.1965C34.4305 27.9203 33.7874 26.8295 34.0635 25.76Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_1613_12654">
        <rect width={44} height={40} fill="white" />
      </clipPath>
    </defs>
  </IconSvg>
);
